module.exports = __webpack_public_path__ + "img/soccer-icon-white.0bfb81d9.png";